import { createTemporaryId } from "../utils/model";

export class PredefinedValue {
  readonly id: string = createTemporaryId();
  readonly value: string;
  
  /**
   * Null means any project or none.
   */
  readonly projectIds?: string[] = null;

  constructor(deriveFrom?: Partial<PredefinedValue>) {
    if (deriveFrom) {
      Object.assign(this, deriveFrom);
    }
  }
}